/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function() {

  $('.slick.marquee').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    draggable: false
  });
  
  $('.article_list_section').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    variableWidth: false,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  if($('.collection-slide').length > 6){
  	$('.collections-list-slider').not('.slick-initialized').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      centerMode: false,
      infinite: true,
      variableWidth: false,
      prevArrow:"<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
        
  $('.Product-Slider-Section').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    prevArrow:"<button type='button' class='slick-prev pull-left slick-arrow'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware' viewBox='0 0 17 14'> <path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path> </svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right slick-arrow'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware' viewBox='0 0 17 14'> <path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path> </svg></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  
  jQuery(".shopify-section--blog-posts .article-item__excerpt").each(function(){
    if(jQuery(this).text().length > 100){
      jQuery(this).text(jQuery(this).text().substr(0,98)+'..');
    }
  });
  
  jQuery(".shopify-section--blog-posts .article-item__title").each(function(){
    if(jQuery(this).text().length > 60){
      jQuery(this).text(jQuery(this).text().substr(0,58)+'..');
    }
  });

  $(".accordion-content").hide(); 
  $(".Product_Accordion_Item:first").addClass('activeToggle');
  $(".Product_Accordion_Item:first .accordion-title").addClass('active');
  $(".Product_Accordion_Item:first .accordion-content").show();
  $(".accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.accordion-content').slideUp();
      $('.accordion-title').not(this).removeClass('active');
      $('.accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.accordion-content').slideDown();
      $(this).parent().addClass("activeToggle"); 
    } else {
      $(this).removeClass('active');
      $(this).next('.accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 	
    }
  });
  
  jQuery(".Blog_Listing .article-item .article-item__excerpt").each(function () {
    function e() {
      jQuery(".Blog_Listing .article-item .article-item__excerpt").css("height", "auto");
      var e = -1;
      jQuery(".Blog_Listing .article-item .article-item__excerpt").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".Blog_Listing .article-item .article-item__excerpt").css("height", e)
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e)
  });

});

$(window).on("load resize orientationchange", function(event){
  if (window.matchMedia('(max-width: 1200px)').matches){
    if($('.collections-list-slider').hasClass('slick-initialized')){
      $('.collections-list-slider').slick('refresh');
    }
    else{
      $('.collections-list-slider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        infinite: true,
        variableWidth: false,
        prevArrow:"<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
        responsive: [
          {
            breakpoint: 9999,
            settings: "unslick"
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  }
}); 

jQuery(document).ready(function() {
  jQuery(window).scroll(function(){
    var sticky = jQuery('.Blog_Template .link-bar'),
        scroll = jQuery(window).scrollTop();

    if (scroll >= 1){
      sticky.addClass('fixed');
    }
    else {
      sticky.removeClass('fixed');
    }

    var announcement_height = $(".shopify-section--announcement-bar").height();
    var header_height = $(".header").height();
    var total_height = announcement_height + header_height
    var final_height = total_height + 1
    $(".Blog_Template .link-bar.fixed").css('top', final_height);
  });
  
  $('body').on('click','.line-item__remove-button', function(e){
  	e.preventDefault();
    var variantId = $(this).closest('.line-item').attr('data-id');
        $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        id: parseFloat(variantId),
        quantity: 0,
      },
    }).then((data) => {
          document.addEventListener('cart:updated', function(event) {
            var cart = event.detail.cart; // Get the updated content of the cart
   
            
          });
          setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            });
            },500);
    });
  });
});


$(window).on("resize", function () {
  
  if ($(window).width() > 740) {
    var leftspace = $(".container").offset().left;
    var padding_left = leftspace + 60;
    $('.article__header-content').css('padding-left',padding_left);
  }

}).resize();

